export function Footer() {
  return (
    <footer className="mt-8 md:mt-12 py-4 md:py-6 text-center border-t border-gray-200">
      <div className="mx-auto max-w-6xl px-0 md:px-6">
        <div className="flex flex-col md:flex-row items-center md:justify-between gap-8">
          {/* App Store Badge */}
          <div className="flex items-center">
            <a
              href="https://apps.apple.com/app/apple-store/id6746954963?pt=123127751&ct=macrowave.co&mt=8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/images/app-store-badge.svg"
                alt="Download on the App Store"
                width="120"
                height="40"
                className="h-10 hover:opacity-80 transition-opacity cursor-pointer"
              />
            </a>
          </div>

          {/* Copyright and Links */}
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-6 text-xs font-serif text-gray-600 text-center">
            <span>
              Broadcasters are responsible for obtaining appropriate licenses for any
              copyrighted content they stream.
            </span>
            <a
              href="mailto:hi@macrowave.co"
              className="hover:text-black transition-colors duration-200"
            >
              Contact Us
            </a>
            <a
              href="/tutorials"
              className="hover:text-black transition-colors duration-200"
            >
              Embed Tutorials
            </a>
            <a
              href="/press"
              className="hover:text-black transition-colors duration-200"
            >
              Press Kit
            </a>
            <a
              href="/privacy"
              className="hover:text-black transition-colors duration-200"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
